'use client';

import { usePathname, useRouter } from 'next/navigation';
import { FC, PropsWithChildren, useCallback, useEffect } from 'react';
import { useStyleGuideContext } from './StyleGuidesContext';

const StyleGuidesRouterProvider: FC<PropsWithChildren<unknown>> = ({ children }): JSX.Element => {
  const router = useRouter();
  const pathname = usePathname();

  const { hasStyleGuides, isChecking } = useStyleGuideContext();

  const onLoad = useCallback(async () => {
    if (!isChecking) {
      if (pathname.endsWith('/style-guides') || pathname.endsWith('/style-guides/list')) {
        if (hasStyleGuides && !pathname.endsWith('/style-guides/list'))
          return router.push('/style-guides/list');
      }
    }
  }, [hasStyleGuides, isChecking, pathname, router]);

  useEffect(() => {
    onLoad();
  }, [onLoad]);

  return <>{children}</>;
};

export default StyleGuidesRouterProvider;
